import React from 'react';
import IconButton from '@mui/material/IconButton';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { useThemeMode } from '../../context/ThemeModeContext';

// Przełącznik trybu: w jasnym pokazuje księżyc (przejdź na ciemny), w ciemnym – słońce.
export default function ThemeToggle({ sx }) {
    const { mode, toggleMode } = useThemeMode();
    const isDark = mode === 'dark';
    const label = isDark ? 'Włącz tryb jasny' : 'Włącz tryb ciemny';

    return (
        <IconButton
            onClick={toggleMode}
            aria-label={label}
            title={label}
            sx={{
                width: 42,
                height: 42,
                color: 'var(--brand-navy)',
                border: '1px solid var(--brand-line)',
                transition: 'background-color 0.2s, transform 0.3s',
                '&:hover': { backgroundColor: 'var(--brand-soft)' },
                '& svg': { fontSize: 22, transition: 'transform 0.3s' },
                '&:hover svg': { transform: isDark ? 'rotate(45deg)' : 'rotate(-20deg)' },
                ...sx,
            }}
        >
            {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
        </IconButton>
    );
}
